import React from 'react';
import { FooterCopyright } from './footer-copyright.component';
import { FooterLegal } from './footer-legal.component';
export const Footer = () => (React.createElement("div", { className: 'mt-auto' },
    React.createElement(FooterLegal, null),
    React.createElement(FooterCopyright, null)));
